import React from "react"

// Progress indicator. Stacked on small screens, inline from `md` up.
export function WizardStepper({ steps, current }) {
  return (
    <ol className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-4">
      {steps.map((label, i) => {
        const active = i === current
        const done = i < current
        return (
          <li key={label} className="flex items-center gap-2">
            <span
              className={[
                "flex h-7 w-7 items-center justify-center rounded-full text-sm font-semibold",
                done && "bg-brand-600 text-white",
                active && "bg-brand-100 dark:bg-brand-900/40 text-brand-700 dark:text-brand-300 ring-2 ring-brand-600",
                !done && !active && "bg-gray-100 dark:bg-gray-800 text-gray-400 dark:text-gray-500",
              ].filter(Boolean).join(" ")}
            >
              {done ? "✓" : i + 1}
            </span>
            <span
              className={[
                "text-sm",
                active ? "font-semibold text-gray-900 dark:text-gray-100" : "text-gray-500 dark:text-gray-400",
              ].join(" ")}
            >
              {label}
            </span>
          </li>
        )
      })}
    </ol>
  )
}
